<template>
    <main-layout>
        <template #header>
            <main-header :title="'Agent 전송 주기 관리'">
            </main-header>
        </template>

        <template #toolbar>
            <v-spacer></v-spacer>
            <v-btn @click="onClickAdd" color="primary">
                추가
            </v-btn>
        </template>

        <template #body>
            <vue-data-table
                    :items="items"
                    :headers="headers"
            >

            </vue-data-table>
        </template>
    </main-layout>
</template>

<script>
    import MainLayout from "@/components/common/layout/MainLayout";
    import MainHeader from "@/components/common/layout/MainHeader";
    import {PATH} from "@/constants";

    export default {
        name: "MonitoringAgentCycleManage",
        components: {MainHeader, MainLayout},
        data() {
            return {
                items: [],
                headers: [
                    {
                        text: "이름",
                        value: "cmdType",
                        width: 200,
                    },
                    {
                        text: "명령어",
                        value: "cmdgetInterval",
                        width: 200,
                    },
                    {
                        text: "등록프린터 목록",
                        value: "regListInterval",
                        width: 200,
                    },
                    {
                        text: "검색프린터 목록",
                        value: "searchListInterval",
                        width: 200,
                    },
                    {
                        text: "프린터 정보 전송",
                        value: "printerinfoInterval",
                        width: 200,
                    },
                    {
                        text: "프린터 정보 수집",
                        value: "getprinterinfoInterval",
                        width: 200,
                    },
                ],
            };
        },
        created() {
            this.load();
        },
        methods: {
            async load() {
                const res = await this.$request(PATH.MONITORING.AGENT_CYCLE_BY_TYPE)
                    .post()
                    .enqueue();
                this.items = res.data;
            },

            onClickAdd() {
                alert("onClickAdd");
            },
        },
    }
</script>

<style scoped>

</style>